exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fi-select-material-dialog {\n  display: block;\n  width: 1200px;\n}\n@media only screen and (max-width: 768px) {\n  fi-select-material-dialog {\n    width: auto;\n  }\n}", ""]);

// exports
